import React, {Component} from 'react';
import Request from '../request';
import jump from 'jump.js';
import './topbar.css';

class Topbar extends Component{
    state = {
        brandList: [],
        main: true,
        about: false,
        duty: false,
        services : false,
        contact: false,
        brand: false,
        menuBackgroundChange: this.props.menuBackgroundChange,
        currentPage: this.props.currentPage,
        hamburger: false
    };
    componentWillMount() {
        Request.get("brand")
            .then(response=>{
                if(response.status === "error"){ console.log(response.data); return false;}
                this.setState({brandList: response.data});
            })
            .catch(reason => console.log(reason));
    }
    componentWillReceiveProps(props) {
        //console.log(props);
        let update = {};
        if(this.state.currentPage !== props.curren){
            update = {
                main: false, about: false, duty: false, brand: false, services: false, contact: false
            };

            switch(props.currentPage){
                case 0: update.main = true; break;
                case 1: update.about = true; break;
                case 2:
                case 3:
                case 4:
                    update.duty = true;
                    break;
                case 5:
                case 6:
                    update.brand = true;
                    break;
                case 7: update.services = true; break;
                case 8: update.contact = true; break;
                default: update.main = true; break;
            }

            update.currentPage = props.currentPage;
        }
        if(this.state.menuBackgroundChange !== props.menuBackgroundChange){
            update.menuBackgroundChange = props.menuBackgroundChange
        }
        if(Object.keys(update).length > 0){
            this.setState(update);
        }
    }
    changeMenu(menuItem, subItem){
        this.setState({
           main: false, about: false, duty: false, brand: false, services: false, contact: false
        });
        switch (menuItem) {
            case "main":
                this.setState({main: true});
                jump("."+menuItem);
            break;
            case "about":
                this.setState({about: true});
                jump("."+menuItem);
                break;
            case "services":
                this.setState({services: true});
                jump("."+menuItem);
                break;
            case "duty":
                this.setState({duty: true});
                jump("."+subItem);
                this.setState({hamburger:false});
                break;
            case "contact":
                this.setState({contact: true});
                jump("."+menuItem);
                break;
            case "brand":
                this.setState({brand: true});
                this.props.selectBrand(subItem);
                // AVK
                if(subItem != 3) jump(".category");
                break;
            default: break;
        }
    }
    toggleHamburger(){
        this.setState({hamburger: !this.state.hamburger});
    }
    toggleHamburgerParent(elementClass){
        console.log(document.getElementsByClassName(elementClass)[0].style.display);
        if(
            document.getElementsByClassName(elementClass)[0].style.display === "none" ||
            document.getElementsByClassName(elementClass)[0].style.display === ""
        ){
            document.getElementsByClassName(elementClass)[0].style.display="block";
        }else{
            document.getElementsByClassName(elementClass)[0].style.display = "none";
        }
    }
    closeMenu(e){
        if(e.target.classList[0] === "hamburgerContainerAll"){
            this.setState({hamburger: false});
        }
    }
    closeHamburger(){
        console.log(this.state.hamburger,"Hamburger Test");
        this.setState({hamburger: false});
    }
    render(){
        const imageLink = (this.props.lang === "tr")?require('../assets/logo_tr.png'):require('../assets/logo_eng.png');
            return (
            <div className={(this.state.menuBackgroundChange === true)?"topbar topbarColored":"topbar"}>
                <div className="logoContainer" onClick={()=>this.changeMenu("main")}>
                    <img alt="" src={imageLink} className="logo" border="0" />
                </div>
                {this.state.hamburger && <div className="hamburgerContainerAll" onClick={this.closeMenu.bind(this)}>
                    <div className="hamburgerContainer">
                        <ul>
                            <li className={this.state.main?"active":""} onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("main"))}>
                                {this.props.lang === "tr" && "ANA SAYFA" }
                                {this.props.lang === "eng" && "HOME" }
                            </li>
                            <li className={this.state.about?"active":""} onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("about"))}>
                                {this.props.lang === "tr" && "HAKKIMIZDA" }
                                {this.props.lang === "eng" && "ABOUT US" }
                            </li>
                            <li className={this.state.duty?"active":"hamburgerParent"}
                                onClick={()=>this.setState({hamburger: true}, ()=>this.toggleHamburgerParent("servicesHamburger"))}>
                                {this.props.lang === "tr" && "HİZMETLERİMİZ"}
                                {this.props.lang === "eng" && "SERVICES"}
                                <ul className="hamburgerSub servicesHamburger">
                                    <li onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("duty", "sale"))}>
                                        {this.props.lang === "tr" && "SATIŞ"}
                                        {this.props.lang === "eng" && "SALE"}
                                    </li>
                                    <li onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("duty", "repair"))}>
                                        {this.props.lang === "tr" && "BAKIM VE ONARIM"}
                                        {this.props.lang === "eng" && "MAINTENANCE AND REPAIR"}
                                    </li>
                                    <li onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("duty", "education"))}>
                                        {this.props.lang === "tr" && "EĞİTİM"}
                                        {this.props.lang === "eng" && "TRAINING"}
                                    </li>
                                </ul>
                            </li>
                            <li className={this.state.brand?"active":"hamburgerParent"}
                                onClick={()=>this.toggleHamburgerParent("brandHamburger")}>
                                {this.props.lang === "tr" && "MARKALAR"}
                                {this.props.lang === "eng" && "BRANDS"}
                                {this.state.brandList.length>0 &&
                                <ul className="hamburgerSub brandHamburger">
                                    {this.state.brandList.map((item, index)=>{
                                        return  <li key={index} onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("brand", item.brand_id))}>{item.title_tr}</li>
                                    })}
                                </ul>
                                }
                            </li>
                            <li className={this.state.services?"active":""} onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("services"))}>
                                {this.props.lang === "tr" && "SERVİS & YEDEK PARÇA"}
                                {this.props.lang === "eng" && "SERVICE AND SPARE PARTS"}

                            </li>
                            <li className={this.state.contact?"active":""} onClick={()=> this.setState({hamburger: false}, ()=>this.changeMenu("contact"))}>
                                {this.props.lang === "tr" && "İLETİŞİM"}
                                {this.props.lang === "eng" && "CONTACT"}
                            </li>
                            <li className="hamburgerLangMenu">
                                <label className={this.props.lang==="tr"?"active":""} onClick={()=>this.setState({hamburger: false},()=>this.props.selectLang("tr"))}>TÜRKÇE</label>/
                                <label className={this.props.lang==="eng"?"active":""} onClick={()=>this.setState({hamburger: false}, ()=>this.props.selectLang("eng"))}>ENGLISH</label>
                            </li>
                        </ul>
                    </div>
                </div>}
                <div className="menu">
                    <div className="hamburgerMenu">
                        <i className="fa fa-bars" onClick={()=>this.toggleHamburger()}></i>
                    </div>

                    <ul>
                        <li className={this.state.main?"active":""} onClick={()=>this.changeMenu("main")}>
                            {this.props.lang === "tr" && "ANA SAYFA" }
                            {this.props.lang === "eng" && "HOME" }
                        </li>
                        <li className={this.state.about?"active":""} onClick={()=>this.changeMenu("about")}>
                            {this.props.lang === "tr" && "HAKKIMIZDA" }
                            {this.props.lang === "eng" && "ABOUT US" }
                        </li>
                        <li className={this.state.duty?"active subMenuParent":"subMenuParent"}>
                            {this.props.lang === "tr" && "HİZMETLERİMİZ"}
                            {this.props.lang === "eng" && "SERVICES"}
                            <ul className="subMenu">
                                <li onClick={()=>this.changeMenu("duty", "sale")}>
                                    {this.props.lang === "tr" && "SATIŞ"}
                                    {this.props.lang === "eng" && "SALE"}
                                </li>
                                <li onClick={()=>this.changeMenu("duty", "repair")}>
                                    {this.props.lang === "tr" && "BAKIM VE ONARIM"}
                                    {this.props.lang === "eng" && "MAINTENANCE AND REPAIR"}
                                </li>
                                <li onClick={()=>this.changeMenu("duty", "education")}>
                                    {this.props.lang === "tr" && "EĞİTİM"}
                                    {this.props.lang === "eng" && "TRAINING"}
                                </li>
                            </ul>
                        </li>
                        <li className={this.state.brand?"active subMenuParent":"subMenuParent"}>
                            {this.props.lang === "tr" && "MARKALAR"}
                            {this.props.lang === "eng" && "BRANDS"}
                            {this.state.brandList.length>0 &&
                                <ul className="subMenu">
                                    {this.state.brandList.map((item, index)=>{
                                        return  <li key={index} onClick={()=>this.changeMenu("brand", item.brand_id)}>{item.title_tr}</li>
                                    })}
                                </ul>
                            }
                        </li>
                        <li className={this.state.services?"active":""} onClick={()=>this.changeMenu("services")}>
                            {this.props.lang === "tr" && "SERVİS & YEDEK PARÇA"}
                            {this.props.lang === "eng" && "SERVICE AND SPARE PARTS"}

                        </li>
                        <li className={this.state.contact?"active":""} onClick={()=>this.changeMenu("contact")}>
                            {this.props.lang === "tr" && "İLETİŞİM"}
                            {this.props.lang === "eng" && "CONTACT"}
                        </li>
                    </ul>
                </div>

                <div className="lang">
                    <label className={this.props.lang==="tr"?"active":""} onClick={()=>this.props.selectLang("tr")}>TR</label>/
                    <label className={this.props.lang==="eng"?"active":""} onClick={()=>this.props.selectLang("eng")}>ENG</label>
                </div>

            </div>
        )
    }
}

export default Topbar;